import {SUPPORTINGDOCUMENTS} from '../constants';
const INITIAL_STATE = [];
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case SUPPORTINGDOCUMENTS:
      return Object.values(action.payload);
    default:
      return state;
  }
}
